import { createStyles, makeStyles } from '@material-ui/core';

export const useScrollStyle = makeStyles((theme) =>
    createStyles({
        scroll: {
            backgroundColor: '#000',
            minHeight: '100vh',
            '&::-webkit-scrollbar': {
                // General scrollbar
                width: '10px',
                height: '10px'
            },
            '&::-webkit-scrollbar-button': {
                // Side buttons
                width: '0px',
                height: '0px'
            },
            '&::-webkit-scrollbar-thumb': {
                // Scrollbar slider
                background: '#555',
                borderRadius: '2px'
            },
            '&::-webkit-scrollbar-thumb:hover': {
                // Slider hover
                background: '#333'
            },
            '&::-webkit-scrollbar-thumb:active': {
                // Slider active
                background: '#555'
            },
            '&::-webkit-scrollbar-track': {
                // Scrollbar track
                background: '#000',
                borderRadius: '2px'
            },
            '&::-webkit-scrollbar-track:hover': {
                // Track hover
                background: '#000'
            },
            '&::-webkit-scrollbar-track:active': {
                // Track active
                background: '#000'
            },
            '&::-webkit-scrollbar-corner': {
                // Scrollbar corners where scrollbars meet
                background: 'transparent'
            },
            '&::-webkit-scrollbar-track-piece:start': {
                background: 'transparent',
                marginTop: theme.mixins.toolbar.minHeight
            }
        }
    })
);
